import { blueprintHeight, blueprintWidth, externalSystemNodes, internalSystemNodes, internalSystemNodesTypes } from "../../config/common";

const PositionService = function (internalNode) {

    this.rectangle = internalNode
    this.movedNode = {}
    this.delegateHalfHeight = 60;
    this.delegateHalfWidth = 60
    this.externalNodeHeight = 100
    this.externalNodeWidth = 100
    this.externalNodes = [4, 20];
    this.internalNodes = [2, 3]
    this.clusterlets = []
    this.edges = []
    this.currentXPosition = this.rectangle.position.x + this.rectangle.style.width
    this.nodesToMoveRight = []
    this.nodesToMoveLeft = []
    this.edgesToModify = [];

    this.attachClusterlets = function (clusterlets) {
        this.clusterlets = clusterlets
    }

    this.attachEdges = function (edges) {
        this.edges = edges
    }

    this.getRectangleRightBorder = function () {
        return this.rectangle.position.x + this.rectangle.style.width
    }

    this.getRectangleLeftBorder = function () {
        return this.rectangle.position.x
    }

    this.getRectangleCenter = function () {
        return this.rectangle.position.x + (this.rectangle.style.width) / 2
    }

    this.getRectangleTopBorder = function () {
        return this.rectangle.position.y
    }

    this.getRectangleBottomBorder = function () {
        return this.rectangle.position.y + this.rectangle.style.height
    }


    this.findRelativePosition = function () {

    }

    this.findAbsolutePosition = function () {

    }

    this.isNodeAllowedToMove = function(position, node) {
        if(node.type === 1) {
            return this.isDelegateAllowedToMove(position)
        }

        if(this.externalNodes.includes(node.type)) {
            return this.isExternalNodeAllowedToDrag(position)
        }

        return { status: true, position}
    }

    this.isNodeAllowedToDrag = function(position,node, actualNode) {
        this.movedNode = node
        this.actualNode = actualNode

        if(node.type === 1) {
            return this.isDelegateAllowedToDrag(position)
        }

        if(this.externalNodes.includes(node.type)) {
            return this.isExternalNodeAllowedToDrag(position)
        }

        return this.returnPosition( position )
    }

    this.isDelegateAllowedToDrag = function(position) {
        let x = position.x;
        let y = position.y;

        const PADDING = 10;
        const APPROX_LABEL_HEIGHT = 70

        if(y - (PADDING) < this.rectangle.position.y) {
            y = this.rectangle.position.y + PADDING;
        }

        if(y + (PADDING + APPROX_LABEL_HEIGHT) > this.rectangle.style.height) {
            y = this.rectangle.style.height - (PADDING + APPROX_LABEL_HEIGHT);
        }
        
        if(x < this.getRectangleLeftBorder() - this.delegateHalfWidth){
            x = this.getRectangleLeftBorder() - this.delegateHalfWidth;
        }

        if(x > this.getRectangleRightBorder() - this.delegateHalfWidth){
            x = this.getRectangleRightBorder() - this.delegateHalfWidth;
        }

        return this.returnPosition({x, y})
    }

    this.isDelegateAllowedToMove = function(position) {

        let x = position.x

        if( this.getRectangleLeftBorder() <= position.x && position.x <= this.getRectangleCenter() ) {
            x = this.getRectangleLeftBorder() - this.delegateHalfWidth
        }

        if(position.x < this.getRectangleLeftBorder()) {
            x = this.getRectangleLeftBorder() - this.delegateHalfWidth
        }

        if(this.getRectangleCenter() <= position.x && position.x <= this.getRectangleRightBorder() ) {
            x =  this.getRectangleLeftBorder() + this.rectangle.style.width - this.delegateHalfWidth
        }

        if(position.x > this.getRectangleRightBorder()) {
            x =  this.getRectangleLeftBorder() + this.rectangle.style.width - this.delegateHalfWidth 
        }

        
        return this.returnPosition( { ...position, x} )
    }

    this.isExternalNodeAllowedToDrag = function (position, margin = 30) {
        const rectLeft   = this.getRectangleLeftBorder();
        const rectTop    = this.getRectangleTopBorder();
        const rectRight  = this.getRectangleRightBorder();
        const rectBottom = this.getRectangleBottomBorder();
      
        let { x, y } = position;
      
        // Expand rectangle by margin
        const safeLeft = rectLeft - margin;
        const safeRight = rectRight + margin;
        const safeTop = rectTop - margin;
        const safeBottom = rectBottom + margin;
      
        // If point lies inside forbidden area → push it to the nearest outside edge
        if (((x + this.externalNodeWidth) >= safeLeft) && x <= safeRight && ((y + this.externalNodeHeight) >= safeTop) && y <= safeBottom) {
          const distLeft = Math.abs(x - safeLeft);
          const distRight = Math.abs(safeRight - x);
          const distTop = Math.abs(y - safeTop);
          const distBottom = Math.abs(safeBottom - y);
      
          const minDist = Math.min(distLeft, distRight, distTop, distBottom);
      
          if (minDist === distLeft) {
            x = safeLeft - this.externalNodeWidth;
          } else if (minDist === distRight) {
            x = safeRight;
          } else if (minDist === distTop) {
            y = safeTop - this.externalNodeHeight;
          } else {
            y = safeBottom;
          }
        }
      
        return this.returnPosition({ x, y });
    }

    this.checkSystemModelChange = function (nodes, currentNodeId, isChangableNode) {
        if(!isChangableNode) return false;
        
        const minWidth = blueprintWidth;
        const minHeight = blueprintHeight;
        const padding = 100;
    
        let lastHorizontalNodeX = 0;
        let lastVerticalNodeY = 0;
        let firstVerticalNodeY = Infinity;

        nodes.forEach((node) => {
            if(internalSystemNodes.includes(node.type)){
                lastHorizontalNodeX = Math.max(lastHorizontalNodeX, node.position.x)
                firstVerticalNodeY = Math.min(firstVerticalNodeY, node.position.y); 
            }
            if(internalSystemNodes.includes(node.type) || node.type === "external_function" && node.id !== currentNodeId){
                lastVerticalNodeY  = Math.max(lastVerticalNodeY, node.position.y)
            }
        })


        let newInternalSystemWidth = lastHorizontalNodeX + this.externalNodeWidth + padding;
        newInternalSystemWidth = Math.max(minWidth, newInternalSystemWidth)

        let newInternalSystemHeight = lastVerticalNodeY + this.externalNodeHeight + padding;
        newInternalSystemHeight = Math.max(newInternalSystemHeight, minHeight)

        this.rectangle.style.height = newInternalSystemHeight
        this.rectangle.style.width = newInternalSystemWidth

        let systemModelDependNodes = this.findSystemModelDependentNodes(nodes, "right")

        return {height: newInternalSystemHeight, width: newInternalSystemWidth, systemModelDependNodes}
    };
      

    this.findSystemModelDependentNodes = (nodes, side) => {
        const updatedNodes = []
        if(side === "right"){
            nodes.forEach(node => {
                if(node.position.x > this.getRectangleCenter() && (externalSystemNodes.includes(node.type) || node.type === "external_function")){
                    let x = node.position.x;

                    if(externalSystemNodes.includes(node.type)){
                        x = this.getRectangleRightBorder() + node.gapToBorder 
                    }else if(node.type === "external_function"){
                        x = this.getRectangleRightBorder() - this.delegateHalfWidth
                    }

                    updatedNodes.push({
                        ...node,
                        position: {...node.position, x }
                    })
                }else if(node.type === "controller_delegate"){
                    updatedNodes.push({
                        ...node,
                        position: {...node.position, x: (this.rectangle.position.x + (this.rectangle.style.width / 2) - 100)}
                    })
                }else if(node.id === "labelNode"){
                    updatedNodes.push({
                        ...node,
                        position: {...node.position, x: this.rectangle.style.width - 120}
                    })
                }
            })
        }

        return updatedNodes
    }
     

    this.findInternalSystemPosition = function () {
        return { status: true, width : this.rectangle.style.width }
    }

    this.findDependencyNodePositions = function (movedNode, clusterlets,edges, nodes) {
        clusterlets.forEach(item => {
            nodes.forEach(node => {
                if(item.id === node.id){
                    item.absolutePosition = node.position
                }
            })
        })

        this.movedNode = movedNode
        this.edges = edges;
        this.clusterlets = clusterlets;
        
        return this.getDependencyNodePositions()
    }

    // To swap the handles of connection line
    this.swapEdgeSourceAndTarget = function(edge) {
        let temp = edge.sourceHandle;
        edge.sourceHandle = ['left', 'right'].includes(edge.sourceHandle) ? edge.targetHandle : edge.sourceHandle;  // Top and bottom handles filtered
        edge.targetHandle = ['left', 'right'].includes(edge.sourceHandle) ? temp : edge.targetHandle;
        this.edgesToModify.push(edge);
    }

    // To find the connection line associated with node1 and node2
    this.findAssociatedEdge = function(nodeId1, nodeId2) {
        let associatedEdge = this.edges.find( edge => edge.source == nodeId1 && edge.target == nodeId2 || edge.source == nodeId2  && edge.target == nodeId1)   
        return associatedEdge;     
    }

     // To swap the handle of connection line associated with node1 and node2 if needed from leftto right
    this.swapLeftHandleToRight = function(nodeId1, nodeId2) {
        const associatedEdge =  this.findAssociatedEdge(nodeId1, nodeId2);
        if (associatedEdge) {
            const swapFlag = associatedEdge.source == nodeId1 && associatedEdge.sourceHandle == 'left' || associatedEdge.target == nodeId1 && associatedEdge.targetHandle == 'left';
            if(swapFlag)  this.swapEdgeSourceAndTarget(associatedEdge); 
        }
    }

    // To swap the handle of connection line associated with node1 and node2 if needed from right to left
    this.swapRightHandleToLeft = function(nodeId1, nodeId2) {
        const associatedEdge =  this.findAssociatedEdge(nodeId1, nodeId2);
        if(associatedEdge) {
            const swapFlag = associatedEdge.source == nodeId1 && associatedEdge.sourceHandle == 'right' || associatedEdge.target == nodeId1 && associatedEdge.targetHandle == 'right';
            if(swapFlag)  this.swapEdgeSourceAndTarget(associatedEdge); 
        }
    }

  

    this.returnPosition = function (position) {
        this.currentXPosition = position.x
        return { status: true, position }
    }

    /**
     * Get dependency node positions
     */
    this.getDependencyNodePositions = function() {
        // Find nodes that can be moved along with the moved node ( dependency nodes)
        let candidateNodes = this.findCandidateNodes(this.movedNode)

        let filteredCandidateNodes = this.filterCandidateNodes(candidateNodes)
        let self = this
        filteredCandidateNodes.forEach(function(node, key){
            filteredCandidateNodes[key].newPosition = self.calculateDependencyPosition(node);
        });
        return filteredCandidateNodes
    }

    /**
     * Find dependency nodes
     */

    this.findCandidateNodes = function(node) {
        let clusterlets = this.clusterlets

        // Find all the edges connected to the current node
        let edges = this.edges.filter(edge => edge.source === node.id || edge.target === node.id)
        
        let nodes = []
        
        // Find all the nodes which are connected to the edges except the current node
        edges.forEach( edge => {
            nodes.push( clusterlets.find( c => (c.id === edge.source || c.id === edge.target) && c.id !== node.id ) )
        })

        return nodes.filter(node => Boolean(node))
    }

    /**
     * Filter the candidate nodes - criteria - do they have multiple connections
     */
    this.filterCandidateNodes = function(associatedNodes) {
        if(this.externalNodes.includes(this.movedNode.type)) {
            let moveFlag = true;
            associatedNodes.forEach(node => {
                if (node.type === 1) {
                    const associatedNodes = this.findCandidateNodes(node);
                    const filtereAssociatedNodes = associatedNodes.filter(node => this.externalNodes.includes(node.type));  // Associated external nodes
                    if (filtereAssociatedNodes.length > 1) {
                        moveFlag = false;
                    }

                }
            });
            if (moveFlag === false) {
                return [];
            }
            return associatedNodes;
        }
        return associatedNodes;
    }

    /**
     * Dependency node with suggested position
     */
    this.calculateDependencyPosition = function(item) {
        const node = JSON.parse(JSON.stringify(item))
        // For sensor ( applies for delegate movment only )

        if(this.externalNodes.includes(node.type) && this.movedNode.type === 1) {
            //is delegate on left now
            if(this.movedNode.position.x < this.getRectangleCenter()) {
                // Node is on the left, do nothing ( may be adjust Y position later)
                this.swapLeftHandleToRight(node.id, this.movedNode.id); 
                if(node.absolutePosition.x < this.getRectangleLeftBorder() ) {
                    return { x: node.absolutePosition.x, y: node.absolutePosition.y} 
                } else {
                    //Node is on the right
                    let currentXGapOnRight = node.absolutePosition.x - this.getRectangleRightBorder()
                    let proposedXPositionOnLeft = this.getRectangleLeftBorder() - currentXGapOnRight
                    return { x: proposedXPositionOnLeft, y: node.absolutePosition.y }

                }
            } else {
                // Delegate is on right
                this.swapRightHandleToLeft(node.id, this.movedNode.id)

                //Is node on the right already?
                if(node.absolutePosition.x > this.getRectangleRightBorder() ) {
                    return { x: node.absolutePosition.x, y: node.absolutePosition.y} 
                } else {
                    let currentXGapOnLeft = this.getRectangleLeftBorder() - node.absolutePosition.x
                    let proposedXPositionOnRight = this.getRectangleRightBorder() + currentXGapOnLeft
                    return { x: proposedXPositionOnRight, y: node.absolutePosition.y }
                }

            }
            
        } else if (this.internalNodes.includes(node.type) && this.movedNode.type === 1) {
            // For handling the handles of edges of internal nodes and moved node
            if(this.movedNode.position.x < this.getRectangleCenter()) { // Delegate is on left
                this.swapRightHandleToLeft(node.id, this.movedNode.id)
            } else {                                                    // Delegate is on right
                this.swapLeftHandleToRight(node.id, this.movedNode.id);
            } 
        } else if (this.externalNodes.includes(this.movedNode.type) && node.type === 1) {
            const associatedInternalNodes = this.findCandidateNodes(node).filter(ele => this.internalNodes.includes(ele.type))  // Internal nodes associated with delegate
            if(node.subType === 'controller'){
                if(this.movedNode.position.x < this.getRectangleCenter()) {
                    this.swapRightHandleToLeft(node.id, this.movedNode.id);
                } else {
                    this.swapLeftHandleToRight(node.id, this.movedNode.id);
                }
            }else if(this.movedNode.position.x < this.getRectangleCenter()) {  // External nodes on left side of  center of internal system
                this.swapRightHandleToLeft(node.id, this.movedNode.id); // For swap handles of the connection line between external node and delegate
               
                // For swap handles of the connection line between internal node and delegate
                associatedInternalNodes.forEach(ele => {
                    this.swapRightHandleToLeft(ele.id, node.id);
                })

                if(node.absolutePosition.x < this.getRectangleCenter()) {
                    return { x: this.getRectangleLeftBorder() - this.delegateHalfWidth, y: node.absolutePosition.y} 
                } else {
                    return { x: this.getRectangleLeftBorder() - this.delegateHalfWidth, y: node.absolutePosition.y}  // Make delegate on left border
                }
                
            } else {// External nodes on right side of right border
                this.swapLeftHandleToRight(node.id, this.movedNode.id); // For swap handles of the connection line between external node and delegate
                
                // For swap handles of the connection line between internal node and delegate
                associatedInternalNodes.forEach(ele => {
                    this.swapLeftHandleToRight(ele.id, node.id);
                })
                if(node.absolutePosition.x > this.getRectangleCenter()) {
                    return { x: this.getRectangleLeftBorder() + this.rectangle.style.width - this.delegateHalfWidth, y: node.absolutePosition.y} 
                } else {
                    return { x: this.getRectangleLeftBorder() + this.rectangle.style.width - this.delegateHalfWidth, y: node.absolutePosition.y}  // Make delegate on right border
                }
            }
        }
        
    }

}


export default PositionService
